import styled from 'styled-components';
import { AutocompleteAddNewItemButton } from '../add-new-item-button/add-new-item-button';

export const StyledAutocompleteAddNewItemButtonContainer = styled(AutocompleteAddNewItemButton)`
  position: sticky;
  bottom: 0;
  align-items: center;
  width: 100%;
  padding: 15px;
  background: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.grey100};
  z-index: 1;
`;
